import { useCallback, useRef } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

import { Mean } from './Mean'

export const ChestInput: React.FC = () => {
  const chestRef = useRef(evaluationAtom.get()?.chest ?? [])

  const handleUpdateField = useCallback(
    (index: number, value: number) => {
      const newArr = [...chestRef.current]
      newArr[index] = +value
      chestRef.current = newArr
      patchEvaluationAtom({ chest: newArr })
    },
    [],
  )

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(1)
  }, [])

  return (
    <>
      <div className='whitespace-nowrap font-bold xl:font-normal'>
        Peitoral (mm) &nbsp;
      </div>
      {chestRef.current.map((val, index) => (
        <div key={`chest-${index}`}>
          <p className='block xl:hidden mb-2'>Medida {index + 1}</p>
          <MaskedInput
            onFocus={handleFocus}
            value={val}
            placeholder='0'
            mask='integer'
            inputMode='numeric'
            onChange={(v) => handleUpdateField(index, v)}
          />
        </div>
      ))}
      <div>
        <p className='block xl:hidden mb-2'>Média</p>
        <Mean field='chest' />
      </div>
    </>
  )
}
